module.exports = __webpack_public_path__ + "static/img/city_jx1.df2746e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/city_jx1.png
// module id = jHtU
// module chunks = 1